// @ts-nocheck

import { BasketActionTypes } from '../../../types/actions/basket';

export const basketItemSetBoomActive = ({
  oddsId,
  isActive,
  skinId,
  stepId,
}: {
  oddsId: number | string;
  isActive: boolean;
  skinId: string;
  stepId: string;
}) => ({
  type: BasketActionTypes.SET_ITEM_BOOM_IS_ACTIVE,
  payload: {
    oddsId,
    isActive,
    skinId,
    stepId,
  },
});

export const basketSetBoomActive = ({
  isActive,
  skinId,
  stepId,
}: {
  isActive: boolean;
  skinId: string;
  stepId: string;
}) => ({
  type: BasketActionTypes.SET_BOOM_IS_ACTIVE,
  payload: {
    isActive,
    skinId,
    stepId,
  },
});

export const basketResetBoomActives = () => ({
  type: BasketActionTypes.RESET_BOOM_IS_ACTIVES,
});
